import Flex from '../../components/utils/Flex'
import Container from '../../components/utils/Container'
import TWButton from '../../components/utils/TWButton/TWButton'

import TModal from '../../components/utils/Modal'
import Post from '../../components/Post'
import CreatePost from '../../components/CreatePost/CreatePost'
import CreateCampaign from '../../components/CreateCampaign'
import CreateSubscription from '../../components/CreateSubscription'
// import { mapGetters, mapMutations } from 'vuex'
// import { getToast } from '../../markup/toast'
import { useState } from 'react'

import PostImage from '../../assets/images/post.png'
import ProfileThumnail from '../../assets/images/profile-thumb.png'

const Feed = () => {

	const [modals, setModals] = useState({
		promo: false,
		subscribe: false,
	})

	const [posts, setPosts] = useState([
		{
			text: `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
							nonumy eirmod tempor invidunt ut labore et dolore.. magna aliquyam
							erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
							et ea rebum`,
			user: {
				fullName: 'RK Anik',
				username: '@rkanik',
				thumbnail: ProfileThumnail,
			},
			images: [PostImage],
		}
	])

	const toggleModal = (modal) => () => {
		setModals(m => ({ ...m, ...modal }))
	}

	return (
		<div className="feed">
			<div className="py-3 md:py-5 lg:py-16 bg-secondary">
				<Container v2>
					<Flex className="space-x-2 md:space-x-4 xl:space-x-6 md:block">
						<TWButton size="md" onClick={toggleModal({ subscribe: true })} className="flex-1">
							Create Subscription
						</TWButton>
						<TWButton size="md" className="flex-1" onClick={toggleModal({ promo: true })}>
							Manage Promotions
						</TWButton>
					</Flex>
					<CreatePost
						className="mt-3 md:mt-7"
						onCreate={post => setPosts(posts => [post, ...posts])}
					/>
					<div className="posts mt-4 md:mt-11">
						{posts.map((post, postIndex) => (
							<Post
								post={post}
								key={postIndex}
								className="mb-7"
							/>
						))}
					</div>
				</Container>
			</div>
			<TModal
				backgroundClose
				className="modal"
				value={modals.subscribe}
				onClose={toggleModal({ subscribe: false })}
			>
				<CreateSubscription
					create="onCreateSubsription"
					onCancel={toggleModal({ subscribe: false })}
				/>
			</TModal>
			<TModal
				className="modal"
				backgroundClose="true"
				value={modals.promo}
				onClose={toggleModal({ promo: false })}
			>
				<CreateCampaign onCancel={toggleModal({ promo: false })} />
			</TModal>
		</div>
	)
}

export default Feed